import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Row, Button } from 'reactstrap';
import AlertModal from '../../../../shared/components/Modal';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from "@material-ui/core/styles";
import FormControlLabel from '@material-ui/core/FormControlLabel';

const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const ModalPlansForm = ({ third, planThird, closeModal, opened, reloadPlans,contract }) => {
    //Campos del Form Plan
    const [name, setName] = useState(null);
    const [type, setType] = useState(null);
    const [diasvencimiento, setDiasvencimiento] = useState(null);
    const [condic, setCondic] = useState(null);
    const [observ, setObserv] = useState(null);
    const [medicineInclude, setMedicineInclude] = useState(false);
    const [negociationType, setNegociationType] = useState(null);
    const [contractNum, setContractNum] = useState(null);

    const [errors, setErrors] = useState({});
    const [openModal, setOpenModal] = useState(opened);
    const [showAlertModal, setAlerShowModal] = useState(false);
    const [messagAlerteModal, setAlertMessageModal] = useState(null);
    const [colorAlertModal, setAlertColorModal] = useState("success");

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    const closeAlertModal = () => {
        setAlerShowModal(false);
        if (colorAlertModal == "success") {
            close();
            reloadPlans();
        }
    }

    const cleanData = () => {
        setName(null);
        setErrors(null);
        setErrors({});
    }

    useEffect(() => {
        mountPlanFields();
    }, []);

    const mountPlanFields = () => {
        if (planThird != null) {
            setName(planThird.nombre);
            setType(planThird.tipo);
            setDiasvencimiento(planThird.diasvencimiento);
            setObserv(planThird.observaciones);
            setCondic(planThird.condiciones);
            setMedicineInclude(planThird.incluye_medicamento);
            setNegociationType(planThird.tipo_negociacion);
            setContractNum(planThird.numero_contrato)
        }
    }

    const validateFields = () => {
        let errors = {};
        let isError = false;
        if (name == null) {
            errors.name = 'El nombre del Plan es Obligatorio';
            isError = true;
        }
        setErrors(errors);
        return isError;
    }

    const addPlan = async () => {
        let isError = validateFields();
        if (isError) {
            return;
        }
        let dataSend = { 
            id_tercero: third.id_tercero, 
            nombre: name,
            id_contrato: contract.id_contrato
        };
        console.log("DatosEnviadosCrearPlan", dataSend)
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                alertModal(true, 'Plan agregado exitosamente');
            }
            else {
                alertModal(false, 'Ha ocurrido un error agregando el Plan');
            }
        }).catch((error) => {
            alertModal(false, 'Ha ocurrido un error agregando el Plan');
        });
    }

    const updatePlan = async () => {
        let isError = validateFields();
        if (isError) {
            return;
        }
        let dataSend = { 
            id_plan: planThird.id_plan, 
            id_tercero: third.id_tercero, 
            nombre: name,
            id_contrato: contract.id_contrato
        };
        console.log("DatosActualizar", dataSend)
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                alertModal(true, 'Plan actualizado exitosamente');
            }
            else {
                alertModal(false, 'Ha ocurrido un error actualizando el Plan');
            }
        }).catch((error) => {
            alertModal(false, 'Ha ocurrido un error actualizando el Plan');
            console.log("ErrorActualizando: ", error)
        });
    }

    const close = () => {
        cleanData();
        closeModal();
    }

    const handleChangeName = (name) => {
        if (name != "") {
            setName(name);
        }
        else {
            setName(null);
        }
    }

    const handleChangeType = (type) => {
        setType(type);
    }

    const handleChangeDaysVenc = (diasvencimiento) => {
        if (diasvencimiento != "") {
            setDiasvencimiento(diasvencimiento);
        } else {
            setDiasvencimiento(null);
        }
    }

    const handleChangeOberv = (observ) => {
        if (observ != "") {
            setObserv(observ);
        } else {
            setObserv(null);
        }
    }

    const handleChangeCondic = (condic) => {
        if (condic != "") {
            setCondic(condic);
        } else {
            setCondic(null);
        }
    }

    const handleChangeNegociationType = (contract) => {
            setNegociationType(contract); 
            console.log(contract)
    }

    const handleNumContract = (numContract) => {
        if (numContract != "") {
            setContractNum(numContract);
        } else {
            setContractNum(null);
        }
        console.log(numContract)
    }


    const handleChangeMedicineInclude = (_medicineInclude) => {
        setMedicineInclude(_medicineInclude);
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    close();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            {planThird == null ? <h5 className="bold-text">Agregar Plan</h5>
                                : <h5 className="bold-text">Actualizar Plan</h5>
                            }
                        </div>
                        <Row>
                            <Col md={12}>
                                <TextField
                                    label="Nombre del Plan"
                                    value={name}
                                    onChange={(event) => {
                                        handleChangeName(event.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                    helperText={errors.hasOwnProperty("name") && name == null ? errors.name : ""}
                                    error={errors.hasOwnProperty("name") && name == null ? true : false}
                                />
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>

                        {planThird == null ? <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                addPlan();
                            }}
                        >
                            Crear
                        </Button> : <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                updatePlan();
                            }}
                        >
                            Actualizar
                        </Button>}
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                close();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal >

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => closeAlertModal(false)}
            />
        </div >
    );
};
export default ModalPlansForm;
